/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Overlay_NotificationsInputs */

const en_us2_ui_overlay_notifications = /** @type {(inputs: Ui_Overlay_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const pt_br2_ui_overlay_notifications = /** @type {(inputs: Ui_Overlay_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações`)
};

const es_419_ui_overlay_notifications = /** @type {(inputs: Ui_Overlay_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones`)
};

const pt_pt2_ui_overlay_notifications = /** @type {(inputs: Ui_Overlay_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações`)
};

const fr_fr2_ui_overlay_notifications = /** @type {(inputs: Ui_Overlay_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const de_de2_ui_overlay_notifications = /** @type {(inputs: Ui_Overlay_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen`)
};

const it_it2_ui_overlay_notifications = /** @type {(inputs: Ui_Overlay_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifiche`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Ui_Overlay_NotificationsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_overlay_notifications = /** @type {((inputs?: Ui_Overlay_NotificationsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Overlay_NotificationsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_overlay_notifications(inputs)
	if (locale === "es-419") return es_419_ui_overlay_notifications(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_overlay_notifications(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_overlay_notifications(inputs)
	if (locale === "de-DE") return de_de2_ui_overlay_notifications(inputs)
	if (locale === "it-IT") return it_it2_ui_overlay_notifications(inputs)
	return en_us2_ui_overlay_notifications(inputs)
});
export { ui_overlay_notifications as "ui-overlay.notifications" }